import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      fr: {
        translation: frTranslations
      }
    },
    fallbackLng: 'en',
    // Default to English: don't auto-detect the browser language.
    // Only honor a language the user has explicitly chosen (stored locally).
    detection: {
      order: ['localStorage', 'querystring'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    },
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;